import {Component, computed, inject, input, OnInit, PLATFORM_ID, Signal} from '@angular/core';
import {UserService} from '@core/services/user.service';
import {WineProduct} from '@core/interfaces/generated/graphql';
import {isPlatformServer} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ReadMoreComponent} from '@layout/components/general/read-more/read-more.component';
import {GridService} from '@core/services/grid.service';
import {
  ProductAuthorComponent
} from '@modules/page/components/product/components/product-author/product-author.component';
import {ProductQuickInfoComponent} from '@layout/components/product/product-quick-info/product-quick-info.component';
import {ProductTagsComponent} from '@layout/components/product/product-tags/product-tags.component';
import {
  ProductDescriptionTextComponent
} from '@modules/page/components/product/components/product-description-section/product-description-text/product-description-text.component';
import {StoryblokVimeoComponent} from '@modules/storyblok/components/storyblok-vimeo/storyblok-vimeo.component';
import {StoryblokVideoComponent} from '@modules/storyblok/components/storyblok-video/storyblok-video.component';
import {
  ProductHighlightSectionComponent
} from '@modules/page/components/product/components/product-highlight-section/product-highlight-section.component';

@Component({
  selector: 'app-product-description-section',
  templateUrl: './product-description-section.component.html',
  styleUrls: ['./product-description-section.component.scss'],
  imports: [RouterModule, FontAwesomeModule, ReadMoreComponent, ProductAuthorComponent, ProductQuickInfoComponent, ProductTagsComponent, ProductDescriptionTextComponent, StoryblokVimeoComponent, StoryblokVideoComponent, ProductHighlightSectionComponent]
})
export class ProductDescriptionSectionComponent implements OnInit {
  userService = inject(UserService);
  gridService = inject(GridService);
  private platformId = inject(PLATFORM_ID);

  isAdmin: Signal<boolean>;

  product = input<WineProduct | undefined>();

  showHighlightSection = computed(() => !!(this.product() as any)?.highlightText);

  ngOnInit(): void {
    this.isAdmin = this.userService.isAdmin();
  }

  maxBodyHeight = computed(() => {
    if (isPlatformServer(this.platformId)) {
      return 600;
    }
    return this.gridService.isLargeSignal() ? 600 : 400;
  });
}

